import { UntypedFormGroup } from '@angular/forms';

export type FormModel<T> = { [P in keyof T]: [T[P], any?] };

export const getFormValue = <Type>(form: UntypedFormGroup, property: string): Type => {
  return form.get(property)?.value as Type;
};